import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "../../utils/toast";

const CorporateBooking = () => {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_APP_DOMAIN}/api/getAllWorkLocations`,
        );
        if (response.data.status) {
          const raw = response.data.data;
          setLocations(Array.isArray(raw) ? raw : []);
        } else {
          setLocations([]);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        setLocations([]);
      }
    };
    fetchLocations();
  }, []);

  const initialValues = {
    company_name: "",
    contact_person: "",
    email: "",
    phone: "",
    location: "",
    details: "",
  };

  const validationSchema = Yup.object({
    company_name: Yup.string().required("Company Name is required"),
    contact_person: Yup.string().required("Contact Person Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
      .required("Phone number is required"),
    location: Yup.string().required("Location is required"),
    details: Yup.string().required("Requirements description is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_APP_DOMAIN}/api/customer/service-inquiry/store`,
        {
          type: "corporate",
          name: values.contact_person,
          email: values.email,
          phone: values.phone,
          details: values.details,
          company_name: values.company_name,
          location: values.location,
        },
      );

      if (response.data.status) {
        toast.success("Inquiry sent successfully! We will contact you soon.");
        resetForm();
      } else {
        toast.error(response.data.message || "Failed to send inquiry.");
      }
    } catch (error) {
      console.error("Error sending corporate inquiry:", error);
      if (error.response && error.response.data && error.response.data.errors) {
        const errors = error.response.data.errors;
        const firstError = Object.values(errors)[0];
        toast.error(Array.isArray(firstError) ? firstError[0] : firstError);
      } else {
        toast.error("An error occurred. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login_formMain booking_formMain">
      <div className="loginForm_inner bookingForm_inner">
        <h2>Corporate Partnerships</h2>
        <p className="mb-4">
          Join forces with Orbi for seamless corporate mobility. Tell us about
          your company's travel needs and let's build a smarter way to move.
        </p>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="form-group mb-3 col-md-6">
                  <Field as="select" name="location" className="form-control">
                    <option value="">Select Location</option>
                    {locations
                      .filter((loc) => loc && typeof loc === "object")
                      .map((loc, idx) => (
                        <option key={loc.id ?? idx} value={loc.name ?? ""}>
                          {loc.name ?? "—"}
                        </option>
                      ))}
                  </Field>
                  <ErrorMessage
                    name="location"
                    component="div"
                    className="text-danger small"
                  />
                </div>
                <div className="form-group mb-3 col-md-6">
                  <Field
                    type="text"
                    name="company_name"
                    className="form-control"
                    placeholder="Company Name"
                  />
                  <ErrorMessage
                    name="company_name"
                    component="div"
                    className="text-danger small"
                  />
                </div>
              </div>

              <div className="row">
                <div className="form-group mb-3 col-md-6">
                  <Field
                    type="text"
                    name="contact_person"
                    className="form-control"
                    placeholder="Contact Person Name"
                  />
                  <ErrorMessage
                    name="contact_person"
                    component="div"
                    className="text-danger small"
                  />
                </div>

                <div className="form-group mb-3 col-md-6">
                  <Field
                    type="text"
                    name="phone"
                    className="form-control"
                    placeholder="Phone Number"
                  />
                  <ErrorMessage
                    name="phone"
                    component="div"
                    className="text-danger small"
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <Field
                  type="text"
                  name="email"
                  className="form-control"
                  placeholder="Email"
                />
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="form-group mb-4">
                <Field
                  as="textarea"
                  name="details"
                  rows="4"
                  className="form-control"
                  placeholder="Tell us about your corporate travel requirements"
                />
                <ErrorMessage
                  name="details"
                  component="div"
                  className="text-danger small"
                />
              </div>

              <div className="login_btn mb-4">
                <button type="submit" className="btn" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Get a Callback"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default CorporateBooking;
